"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventAsSeasonSegment = exports.SeasonAsSeasonSegment = void 0;
const Events_1 = require("../entity/Events");
const ProgramSeason_1 = require("../programs-seasons/entities/ProgramSeason");
const enums_service_1 = require("./enums.service");
/**
 */
class SeasonAsSeasonSegment extends ProgramSeason_1.ProgramSeason {
    constructor() {
        super(...arguments);
        this.segmentType = enums_service_1.ResourceNameTypeEnum.PROGRAM_SEASON;
    }
}
exports.SeasonAsSeasonSegment = SeasonAsSeasonSegment;
/**
 */
class EventAsSeasonSegment extends Events_1.Event {
    constructor() {
        super(...arguments);
        this.segmentType = enums_service_1.ResourceNameTypeEnum.EVENT;
    }
}
exports.EventAsSeasonSegment = EventAsSeasonSegment;
//# sourceMappingURL=interfaces.service.js.map